// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-picker {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.color-picker.disabled .handle-button {
  border-color: var(--disabled-border-color);
  opacity: 0.5;
  cursor: default;
}
.color-picker .handle-button, .color-picker .pick-button {
  border: 1px solid var(--white-color-light);
  cursor: pointer;
  transition: box-shadow 0.3s;
}
.color-picker .handle-button:hover, .color-picker .pick-button:hover {
  box-shadow: var(--omni-shadow-hidden);
}
.color-picker .handle-button {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  border: solid 1px var(--border-color);
}
.color-picker .pick-button-area {
  position: relative;
}
.color-picker .pick-button-area .pick-button {
  width: 34px;
  height: 34px;
  border-radius: 17px;
  border: solid 1px var(--border-color);
}
.color-picker .pick-button-area .pick-button.conic {
  background: conic-gradient(red, yellow, lime, cyan, blue, magenta, red);
}
.color-picker .pick-button-area .pick-mark {
  color: var(--white-color-lightest);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.color-picker .pick-button-area.selected .pick-button {
  transition: box-shadow 0s;
  border: solid 3px var(--white-color-lightest);
  box-shadow: 0 0 0 4px var(--primary-color-main);
}
.color-picker .hex-input-area {
  border-radius: 8px;
  border: solid 1px var(--border-color);
  overflow: hidden;
}
.color-picker .hex-input-area .label {
  background-color: var(--disabled-bg-color);
  width: 96px;
}
.color-picker .hex-input-area .hex-input {
  border-radius: 0;
  border: none;
}
.color-picker .hex-input-area .hex-input-button {
  border-radius: 0;
  width: 96px;
}
.color-picker .picker-palette-area {
  position: fixed;
  z-index: var(--z-index-overlay);
}
.color-picker .picker-palette-area .picker-palette-area-group {
  position: relative;
}
.color-picker .picker-palette-area .picker-palette-area-group .picker-palette {
  width: 296px;
  height: 220px;
  position: relative;
  z-index: var(--z-index-local-default);
}
.color-picker .picker-palette-area .picker-palette-area-group .picker-palette.analog-picker {
  height: 308px;
}
.color-picker .picker-palette-area .picker-palette-area-group .picker-palette .sketch-picker {
  box-shadow: none !important;
  width: 244px !important;
}
.color-picker .picker-palette-area .picker-palette-area-group .picker-palette .sketch-picker > :nth-child(3), .color-picker .picker-palette-area .picker-palette-area-group .picker-palette .sketch-picker > :nth-child(4) {
  display: none !important;
}
.color-picker .picker-palette-area .picker-palette-area-group .picker-palette-shadow {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  box-shadow: var(--omni-shadow-hidden);
  z-index: var(--z-index-local-under-1);
  border-radius: 8px;
  background-color: transparent;
}
.color-picker .picker-palette-area .picker-palette-area-group .picker-palette-shadow:before {
  background-color: #fff;
  content: "";
  height: 20px;
  left: -10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%) rotate(45deg) skew(-12deg, -12deg);
  width: 20px;
  z-index: var(--z-index-local-under-2);
  box-shadow: var(--omni-shadow-hidden);
}
.color-picker .picker-area {
  position: absolute;
  z-index: var(--z-index-local-over-2);
}
.color-picker .close-button {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/ColorPicker.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACD;AAGE;EACC,0CAAA;EACA,YAAA;EACA,eAAA;AADH;AAKC;EACC,0CAAA;EACA,eAAA;EACA,2BAAA;AAHF;AAKE;EACC,qCAAA;AAHH;AAOC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;AALF;AAQC;EACC,kBAAA;AANF;AAOE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;AALH;AAOG;EACC,uEAAA;AALJ;AAWE;EACC,kCAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AATH;AAaG;EACC,yBAAA;EACA,6CAAA;EACA,+CAAA;AAXJ;AAgBC;EACC,kBAAA;EACA,qCAAA;EACA,gBAAA;AAdF;AAgBE;EACC,0CAAA;EACA,WAAA;AAdH;AAiBE;EACC,gBAAA;EACA,YAAA;AAfH;AAkBE;EACC,gBAAA;EACA,WAAA;AAhBH;AAoBC;EACC,eAAA;EACA,+BAAA;AAlBF;AAoBE;EACC,kBAAA;AAlBH;AAmBG;EACC,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qCAAA;AAjBJ;AAmBI;EACC,aAAA;AAjBL;AAmBI;EACC,2BAAA;EACA,uBAAA;AAjBL;AAmBK;EAEC,wBAAA;AAlBN;AAsBG;EACC,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,qCAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;AApBJ;AAsBI;EACC,sBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,8DAAA;EACA,WAAA;EACA,qCAAA;EACA,qCAAA;AApBL;AA2BC;EACC,kBAAA;EACA,oCAAA;AAzBF;AA4BC;EACC,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AA1BF","sourcesContent":[".color-picker {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tposition: relative;\r\n\r\n\t// 非活性時は色見本を残したまま、触れないことが分かるようにする\r\n\t&.disabled {\r\n\t\t.handle-button {\r\n\t\t\tborder-color: var(--disabled-border-color);\r\n\t\t\topacity: 0.5;\r\n\t\t\tcursor: default;\r\n\t\t}\r\n\t}\r\n\r\n\t.handle-button, .pick-button {\r\n\t\tborder: 1px solid var(--white-color-light);\r\n\t\tcursor: pointer;\r\n\t\ttransition: box-shadow 0.3s;\r\n\r\n\t\t&:hover{\r\n\t\t\tbox-shadow: var(--omni-shadow-hidden);\r\n\t\t}\r\n\t}\r\n\r\n\t.handle-button {\r\n\t\twidth: 30px;\r\n\t\theight: 30px;\r\n\t\tborder-radius: 15px;\r\n\t\tborder: solid 1px var(--border-color);\r\n\t}\r\n\r\n\t.pick-button-area{\r\n\t\tposition: relative;\r\n\t\t.pick-button {\r\n\t\t\twidth: 34px;\r\n\t\t\theight: 34px;\r\n\t\t\tborder-radius: 17px;\r\n\t\t\tborder: solid 1px var(--border-color);\r\n\r\n\t\t\t&.conic{\r\n\t\t\t\tbackground: conic-gradient(\r\n\t\t\t\t\tred, yellow, lime, cyan, blue, magenta, red\r\n\t\t\t\t);\r\n\t\t\t}\r\n\t\t}\r\n\t\t\r\n\t\t.pick-mark{\r\n\t\t\tcolor: var(--white-color-lightest);\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 0;\r\n\t\t\tbottom: 0;\r\n\t\t\tleft: 0;\r\n\t\t\tright: 0;\r\n\t\t\tmargin: auto;\r\n\t\t}\r\n\r\n\t\t&.selected{\r\n\t\t\t.pick-button {\r\n\t\t\t\ttransition: box-shadow 0s;\r\n\t\t\t\tborder: solid 3px var(--white-color-lightest);\r\n\t\t\t\tbox-shadow: 0 0 0 4px var(--primary-color-main);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.hex-input-area{\r\n\t\tborder-radius: 8px;\r\n\t\tborder: solid 1px var(--border-color);\r\n\t\toverflow: hidden;\r\n\r\n\t\t.label{\r\n\t\t\tbackground-color: var(--disabled-bg-color);\r\n\t\t\twidth: 96px;\r\n\t\t}\r\n\r\n\t\t.hex-input{\r\n\t\t\tborder-radius: 0;\r\n\t\t\tborder: none;\r\n\t\t}\r\n\r\n\t\t.hex-input-button{\r\n\t\t\tborder-radius: 0;\r\n\t\t\twidth: 96px;\r\n\t\t}\r\n\t}\r\n\r\n\t.picker-palette-area {\r\n\t\tposition: fixed;\r\n\t\tz-index: var(--z-index-overlay);\r\n\r\n\t\t.picker-palette-area-group{\r\n\t\t\tposition: relative;\r\n\t\t\t.picker-palette{\r\n\t\t\t\twidth: 296px;\r\n\t\t\t\theight: 220px;\r\n\t\t\t\tposition: relative;\r\n\t\t\t\tz-index: var(--z-index-local-default);\r\n\r\n\t\t\t\t&.analog-picker{\r\n\t\t\t\t\theight: 308px;\r\n\t\t\t\t}\r\n\t\t\t\t.sketch-picker{\r\n\t\t\t\t\tbox-shadow: none !important;\r\n\t\t\t\t\twidth: 244px !important;\r\n\r\n\t\t\t\t\t& > :nth-child(3),\r\n\t\t\t\t\t& > :nth-child(4) {\r\n\t\t\t\t\t\tdisplay: none !important;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\t.picker-palette-shadow{\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\ttop: 0;\r\n\t\t\t\tbottom: 0;\r\n\t\t\t\tright: 0;\r\n\t\t\t\tleft: 0;\r\n\t\t\t\tbox-shadow: var(--omni-shadow-hidden);\r\n\t\t\t\tz-index: var(--z-index-local-under-1);\r\n\t\t\t\tborder-radius: 8px;\r\n\t\t\t\tbackground-color: transparent;\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: #fff;\r\n\t\t\t\t\tcontent: \"\";\r\n\t\t\t\t\theight: 20px;\r\n\t\t\t\t\tleft: -10px;\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\ttop: 50%;\r\n\t\t\t\t\ttransform: translateY(-50%) rotate(45deg) skew(-12deg, -12deg);\r\n\t\t\t\t\twidth: 20px;\r\n\t\t\t\t\tz-index: var(--z-index-local-under-2);\r\n\t\t\t\t\tbox-shadow: var(--omni-shadow-hidden);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t.picker-area {\r\n\t\tposition: absolute;\r\n\t\tz-index: var(--z-index-local-over-2);\r\n\t}\r\n\r\n\t.close-button {\r\n\t\tposition: fixed;\r\n\t\ttop: 0;\r\n\t\tright: 0;\r\n\t\tbottom: 0;\r\n\t\tleft: 0;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
